import { useMutation } from '@tanstack/react-query';

import {
  promptMigrationApi,
  type AnalyzePromptResponse,
  type ExecuteMigrationResponse,
  type MigrationBlock,
} from '../services/promptMigrationApi';

export function useAnalyzePrompt(agentId: string | undefined) {
  return useMutation<
    AnalyzePromptResponse,
    Error,
    { systemPrompt: string; databaseIds: string[] }
  >({
    mutationFn: ({ systemPrompt, databaseIds }) => {
      const id = agentId || 'draft';
      return promptMigrationApi.analyzePrompt(id, systemPrompt, databaseIds);
    },
  });
}

export function useExecuteMigration(agentId: string | undefined) {
  return useMutation<
    ExecuteMigrationResponse,
    Error,
    { block: MigrationBlock; currentPrompt: string }
  >({
    mutationFn: ({ block, currentPrompt }) => {
      const id = agentId || 'draft';
      return promptMigrationApi.executeMigration(id, block, currentPrompt);
    },
  });
}

/**
 * Refinador de estrutura — chamado pelo step final do wizard de
 * Otimizar Prompt após a migração pra base. Reusa o `PromptRewriterService`
 * (mesmo do Coach Apply Diff) pra reorganizar o prompt em tags XML
 * do catálogo sem perder conteúdo.
 */
export function useRefinePromptStructure(agentId: string | undefined) {
  return useMutation<
    { newSystemPrompt: string; changeSummary: string },
    Error,
    { currentPrompt: string }
  >({
    mutationFn: ({ currentPrompt }) => {
      const id = agentId || 'draft';
      return promptMigrationApi.refinePromptStructure(id, currentPrompt);
    },
  });
}
